import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const creditWalletSlice = createSlice({
  name: "creditWallet",

  initialState: {
    creditWalletData: [],
    creditAmount: null,
    assignedAmount: null,
    isError1: false,
  },

  reducers: {
    fetchCreditWalletSuccess: (state, action) => {
      state.isError1 = false;
      state.creditWalletData = action.payload;
    },
    fetchCreditAmount: (state, action) => {
      state.isError1 = false;
      state.creditAmount = action.payload;
    },
    fetchAssignedAmount: (state, action) => {
      state.isError1 = false;
      state.assignedAmount = action.payload;
    },
    fetchCreditWalletFailure: (state) => {
      state.isError1 = true;
    },
    resetCreditWallet: (state) => {
      state.creditWalletData = [];
      state.creditAmount = null;
      state.assignedAmount = null;
      state.isError1 = false;
    },
  },
});

export const {
  fetchCreditWalletSuccess,
  fetchCreditAmount,
  fetchAssignedAmount,
  fetchCreditWalletFailure,
  resetCreditWallet,
} = creditWalletSlice.actions;

export const fetchCreditWallet = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/credit-wallet`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: config.token,
        Accept: "application/json",
      },
    });

    dispatch(fetchAssignedAmount(response.data.assign_credit_balance));
    dispatch(fetchCreditAmount(response.data.credit_balance));
    dispatch(fetchCreditWalletSuccess(response.data.transaction.data));
  } catch (error) {
    dispatch(fetchCreditWalletFailure());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};

export default creditWalletSlice.reducer;
